import React from "react";
import { _t } from "app/i18n/i18n";
import { isIntranetPath, isPublicPath } from "lib/routing";

export const DownloadExcelLink = (props) =>
  isIntranetPath() && !isPublicPath() ? (
    <ExternalLink
      url="/research/japi/analysts/download"
      label={_t("Download to Excel")}
      icon="fas fa-file-excel text-success"
      className="float-right"
      {...props}
    />
  ) : null;

export const ExternalLink = ({ url, label, icon, className = "", target = "_blank" }) => (
  <a className={`text-primary ${className}`} href={url} target={target} rel="noopener noreferrer">
    <i className={`${icon} fa-lg mr-2`} />
    {label}
  </a>
);
